import React from "react";
import moment from "moment";
import { Link } from "react-router-dom";
import {
    RenderNumber,
    RenderKilogramo,
} from "../../../../../../Utils/renderField/renderReadField";
const verIcon = require("assets/img/icons/ver.png");
const revertirIcon = require("assets/img/icons/inactivo.png");

export const SalidasTable = ({ salidas, onRevertir }) => {
    return (
        <div className="new-table-wrapper ingresos-bodega__table-wrapper">
            <table className="table-striped">
                <thead>
                    <tr>
                        <th>Fecha - hora</th>
                        <th>Tipo de salida</th>
                        <th>Destino</th>
                        <th>Usuario</th>
                        <th>Cant. pallets</th>
                        <th>Cant. pacas</th>
                        <th>Kg sobrante</th>
                        <th>Acciones</th>
                    </tr>
                </thead>
                <tbody>
                    {salidas.length === 0 && (
                        <tr>
                            <td colSpan={8} className="text-center">
                                No hay registros de salidas de bodega
                            </td>
                        </tr>
                    )}
                    {salidas.map((item) => {
                        return (
                            <tr key={item.id}>
                                <td className="text-center text-nowrap">
                                    {item.fecha_con_desfase
                                        ? moment(item.fecha_con_desfase).format(
                                              "DD/MM/YYYY - HH:mm",
                                          )
                                        : "N/A"}
                                </td>
                                <td className="text-center text-nowrap">
                                    {item.tipo_salida_display}
                                </td>
                                <td className="text-center text-nowrap">
                                    {item.tipo_destino_display}
                                </td>
                                <td className="text-center text-nowrap">
                                    {item.usuario_nombre || "No definido"}
                                </td>
                                <td className="text-center">
                                    <RenderNumber
                                        value={item.total_pallets}
                                        decimalScale={0}
                                    />
                                </td>
                                <td className="text-center">
                                    <RenderNumber
                                        value={item.total_pacas}
                                        decimalScale={0}
                                    />
                                </td>
                                <td className="text-center">
                                    <RenderKilogramo
                                        value={item.total_kg_secos_sobrante}
                                        decimalScale={2}
                                    />
                                </td>
                                <td className="text-center text-nowrap">
                                    <div className="table-actions">
                                        <Link
                                            to={`/produccion-bodega/salidas/${item.id}/ver-boleta`}
                                        >
                                            <img
                                                src={verIcon}
                                                alt="Ver"
                                                className="action_img"
                                                title="Ver"
                                            />
                                        </Link>
                                        <img
                                            src={revertirIcon}
                                            style={{
                                                width: "21.5px",
                                                height: "21.5px",
                                            }}
                                            alt="Revertir"
                                            className="action_img"
                                            title="Revertir salida"
                                            onClick={() => onRevertir(item)}
                                        />
                                    </div>
                                </td>
                            </tr>
                        );
                    })}
                </tbody>
            </table>
        </div>
    );
};
